export const techSupportThemes = [
  "הודעות",
  "הוספת שם",
  "כללי",
  "איזור האישי",
  "לשנות הגדרות",
];
